﻿import {DateTime, DayOfWeek} from "@2d-front-monorepo/core";
import ParkingPrebookingAvailabilityType from "../enums/ParkingPrebookingAvailabilityType";
import {ParkingPrebookingAvailabilityEntry} from "../types/ParkingPrebookingAvailabilityEntry";

export function isDateRangeValid(availability: ParkingPrebookingAvailabilityEntry[], startDate: DateTime, endDate: DateTime, alwaysValidWeekDays: DayOfWeek[]): boolean {
	const entries = availability;
	if (entries.length === 0) {
		return false;
	}

	const relevantEntries = entries.filter(entry =>
		entry.startDate < endDate && entry.endDate > startDate
	);

	if (relevantEntries.length === 0) {
		return false;
	}

	let currentDate = startDate;

	for (const entry of relevantEntries) {
		if (currentDate < entry.startDate) {
			return false;
		}

		if (entry.type !== ParkingPrebookingAvailabilityType.Available) {
			if (!alwaysValidWeekDays.includes(currentDate.getDayOfWeek())) {
				return false;
			}
		}

		currentDate = DateTime.fromTimestamp(Math.max(+currentDate, +entry.endDate));
		if (currentDate >= endDate) {
			return true;
		}
	}

	return false;
}
